import { Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="glass-panel border-t-0 border-x-0 border-b-0 rounded-none">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col items-center justify-center gap-6">
          <div className="flex flex-col items-center gap-2">
            <img src="/logo.png" alt="Melody Art Gallery" className="h-16 w-auto drop-shadow-lg" />
            <div className="text-center">
              <h3 className="font-display text-xl font-bold text-gradient tracking-wider">
                Melody Art Gallery
              </h3>
              <p className="font-sans text-[10px] text-muted-foreground uppercase tracking-[0.2em] font-light">
                Premium Artistic Expression
              </p>
            </div>
          </div>
          <a
            href="https://www.instagram.com/dreaminggirl4ever"
            target="_blank"
            rel="noopener noreferrer"
            className="gradient-accent text-primary-foreground px-6 py-2 rounded-full shadow-glow inline-flex items-center gap-2 text-sm font-medium hover:opacity-90 transition-all active:scale-95"
          >
            <Instagram className="h-4 w-4" />
            @dreaminggirl4ever
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
